import { ChemicalCategoryBM } from '../../types/BusinessModel/TankCleaning/ChemicalCategoryBM';
import { ChemicalCategory } from '../../types/ViewModel/TankCleaning/ChemicalCategory';

export const createCategory = (category: ChemicalCategoryBM): ChemicalCategory => {
    return {
        categoryId: category.categoryId,
        name: category.name,
        order: category.order,
    };
};

export const createCategoryList = (categorys: ChemicalCategoryBM[]) => categorys.map((category) => createCategory(category));
